import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import VueApollo from "vue-apollo";
import { coreClient } from "./apollo";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

Vue.use(Datetime);

Vue.use(VueApollo);
Vue.use(Vuetify, {
  theme: {
    primary: "#d96c6c",
  },
});

const Provider = new VueApollo({
  clients: {
    core: coreClient,
  },
  defaultClient: coreClient,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider: Provider,
  render: (h) => h(App),
}).$mount("#app");
